export enum PaginationEnum{
    page1 = 1,
    page2 = 3,
    page3 = 5,
    page4 = 7,
    page5 = 9,
  }
  